import { Checkbox, ConfigProvider } from "antd";

export default function SingleCheckBoxItem({
  purpose,
  mainLabel,
  checkboxLabel,
  isChecked,
  onChangeHandler,
}) {
  return (
    <div className="flex flex-row m-[1px] text-base items-center gap-4">
      {mainLabel && mainLabel.length > 0 && (
        <div className="w-[400px] font-ubold">{mainLabel}</div>
      )}
      <div className="flex flex-row w-full gap-14">
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: "#572D86",
              colorPrimaryBorder: "#572D86",
              colorPrimaryHover: "#572D86",
              controlOutline: "#572D86",
              colorBorder: "#572D86",
            },
          }}
        >
          <Checkbox
            checked={isChecked}
            onChange={(e) => onChangeHandler(purpose, e)}
          >
            {checkboxLabel}
          </Checkbox>
        </ConfigProvider>
      </div>
    </div>
  );
}
